import React from 'react';
import { ExternalLink } from 'lucide-react';
import LegalLayout from './LegalLayout';

const PrivacyPolicyPage = () => {
  const sections = [
    { id: 'privacy-1', label: '1. 개인정보의 수집 및 이용 목적' },
    { id: 'privacy-2', label: '2. 수집하는 개인정보 항목' },
    { id: 'privacy-3', label: '3. 개인정보의 보유 및 이용기간' },
    { id: 'privacy-4', label: '4. 개인정보의 제3자 제공' },
    { id: 'privacy-5', label: '5. 개인정보의 파기' },
    { id: 'privacy-6', label: '6. 이용자의 권리·의무 및 행사방법' },
    { id: 'privacy-7', label: '7. 개인정보 보호책임자' },
    { id: 'privacy-8', label: '8. 권익침해 구제방법' },
  ];

  return (
    <LegalLayout
      title="개인정보취급방침"
      lastUpdated="2025년 1월 20일"
      sections={sections}
    >
      <section id="privacy-1" className="scroll-mt-24">
        <h2 className="text-xl font-semibold text-primary mb-4">1. 개인정보의 수집 및 이용 목적</h2>
        <p className="mb-2">
          회사는 다음의 목적을 위하여 개인정보를 처리합니다. 처리하고 있는 개인정보는 다음의 목적 이외의 용도로는 이용되지 않으며, 이용 목적이 변경되는 경우에는 별도의 동의를 받는 등 필요한 조치를 이행할 예정입니다.
        </p>
        <ul className="list-disc list-inside space-y-1 ml-4">
          <li>회원가입 및 관리: 회원 가입의사 확인, 회원제 서비스 제공에 따른 본인 식별·인증</li>
          <li>서비스 제공: 부고 등록 및 관리, 화환 주문 및 배송 서비스 제공</li>
          <li>고객 지원: 고객 문의 응대, 공지사항 전달</li>
        </ul>
      </section>

      <section id="privacy-2" className="scroll-mt-24">
        <h2 className="text-xl font-semibold text-primary mb-4">2. 수집하는 개인정보 항목</h2>
        <p className="mb-2">회사는 다음의 개인정보 항목을 수집하고 있습니다:</p>
        <ul className="list-disc list-inside space-y-1 ml-4">
          <li>필수항목: 이름, 이메일, 전화번호</li>
          <li>선택항목: 배송지 주소</li>
          <li>자동수집항목: IP주소, 쿠키, 방문일시, 서비스 이용 기록</li>
        </ul>
      </section>

      <section id="privacy-3" className="scroll-mt-24">
        <h2 className="text-xl font-semibold text-primary mb-4">3. 개인정보의 보유 및 이용기간</h2>
        <p className="mb-2">
          회사는 법령에 따른 개인정보 보유·이용기간 또는 정보주체로부터 개인정보를 수집 시에 동의받은 개인정보 보유·이용기간 내에서 개인정보를 처리·보유합니다.
        </p>
        <ul className="list-disc list-inside space-y-1 ml-4">
          <li>회원정보: 회원 탈퇴 시까지 (단, 관계 법령에 따라 보존 필요 시 해당 기간까지)</li>
          <li>주문/결제 정보: 전자상거래법에 따라 5년간 보관</li>
        </ul>
      </section>

      <section id="privacy-4" className="scroll-mt-24">
        <h2 className="text-xl font-semibold text-primary mb-4">4. 개인정보의 제3자 제공</h2>
        <p>
          회사는 원칙적으로 이용자의 개인정보를 외부에 제공하지 않습니다. 다만, 다음의 경우에는 예외로 합니다:
        </p>
        <ul className="list-disc list-inside space-y-1 ml-4">
          <li>이용자가 사전에 동의한 경우</li>
          <li>법령의 규정에 의거하거나, 수사 목적으로 법령에 정해진 절차와 방법에 따라 수사기관의 요구가 있는 경우</li>
        </ul>
      </section>

      <section id="privacy-5" className="scroll-mt-24">
        <h2 className="text-xl font-semibold text-primary mb-4">5. 개인정보의 파기</h2>
        <p>
          회사는 개인정보 보유기간의 경과, 처리목적 달성 등 개인정보가 불필요하게 되었을 때에는 지체 없이 해당 개인정보를 파기합니다.
        </p>
      </section>

      <section id="privacy-6" className="scroll-mt-24">
        <h2 className="text-xl font-semibold text-primary mb-4">6. 이용자의 권리·의무 및 행사방법</h2>
        <p className="mb-2">
          이용자는 개인정보주체로서 다음과 같은 권리를 행사할 수 있습니다:
        </p>
        <ul className="list-disc list-inside space-y-1 ml-4">
          <li>개인정보 열람 요구</li>
          <li>개인정보 오류 등이 있을 경우 정정 요구</li>
          <li>개인정보 삭제 요구</li>
          <li>개인정보 처리정지 요구</li>
        </ul>
      </section>

      <section id="privacy-7" className="scroll-mt-24">
        <h2 className="text-xl font-semibold text-primary mb-4">7. 개인정보 보호책임자</h2>
        <div className="space-y-1">
          <p><strong>성명:</strong> 김철수</p>
          <p><strong>직책:</strong> 개인정보보호팀장</p>
          <p>
            <strong>연락처:</strong>{' '}
            <a
              href="mailto:privacy@mobilefuneral.co.kr"
              className="text-primary-700 hover:underline"
            >
              privacy@mobilefuneral.co.kr
            </a>
          </p>
        </div>
      </section>

      <section id="privacy-8" className="scroll-mt-24">
        <h2 className="text-xl font-semibold text-primary mb-4">8. 권익침해 구제방법</h2>
        <p className="mb-2">
          개인정보 침해로 인한 신고나 상담이 필요하신 경우 아래 기관에 문의하실 수 있습니다.
        </p>
        <ul className="list-disc list-inside space-y-1 ml-4">
          <li>
            개인정보분쟁조정위원회: (국번없이) 1833-6972{' '}
            <a
              href="https://www.kopico.go.kr"
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center gap-1 text-sm text-primary-700 hover:underline"
            >
              kopico.go.kr <ExternalLink size={14} aria-hidden="true" />
            </a>
          </li>
          <li>
            개인정보침해신고센터(KISA): (국번없이) 118{' '}
            <a
              href="https://privacy.kisa.or.kr"
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center gap-1 text-sm text-primary-700 hover:underline"
            >
              privacy.kisa.or.kr <ExternalLink size={14} aria-hidden="true" />
            </a>
          </li>
          <li>대검찰청 사이버수사과: (국번없이) 1301</li>
          <li>경찰청 사이버수사국: (국번없이) 182</li>
        </ul>
      </section>

      <div className="mt-8 p-4 bg-accent-50 rounded-lg border border-accent-200">
        <p className="text-sm text-accent-700">
          본 개인정보취급방침은 프론트엔드 목업 프로젝트를 위한 예시 문서입니다.
          실제 서비스에서는 법률 전문가의 검토를 받은 문서를 사용해야 합니다.
        </p>
      </div>
    </LegalLayout>
  );
};

export default PrivacyPolicyPage;
